/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChainSearchRequest
 */
export interface ChainSearchRequest {
    /**
     * 
     * @type {string}
     * @memberof ChainSearchRequest
     */
    key: string;
}

export function ChainSearchRequestFromJSON(json: any): ChainSearchRequest {
    return ChainSearchRequestFromJSONTyped(json, false);
}

export function ChainSearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChainSearchRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': json['key'],
    };
}

export function ChainSearchRequestToJSON(value?: ChainSearchRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
    };
}


